import { useEffect } from "react";

export function useIframeHeight() {
  useEffect(() => {
    const publish = () => {
      window.parent.postMessage(document.body.offsetHeight, "*");
    };
    publish();
    if (typeof ResizeObserver === "undefined") {
      return undefined;
    }
    const observer = new ResizeObserver(publish);
    observer.observe(document.body);
    return () => observer.disconnect();
  }, []);
}

export function requestParentScroll() {
  window.parent.postMessage("scroll", "*");
}
